<style scoped lang="scss">
    .product-comparision__row {
        width: auto;
    }

    /*Mobile adjustements*/
    @media only screen and (max-width: 767px) {

        .product-comparision {

            .parametric-intro {
                padding-top: 0;
                margin: 0 !important;
            }
        }

        .product-comparision {

            .page-title {
                padding: 15px 0 !important;
            }
        }

        .product-comparision__content {
            margin-bottom: 36px;
            width: calc(100% + 15px);
        }
    }

    /*Tablet adjustements*/
    @media only screen and (max-width: 992px) {

        .product-comparision__content {
            overflow-x: auto !important;
        }
    }

    thead.product-comparision__thead tr:nth-child(2) th {
        border-top: 1px solid #ddd;
    }

    .table-actions {
        vertical-align: top;
    }

    table.product-comparision__table {
        border: 0;
    }

    table.product-comparision__table thead tr:first-child .product-comparison-headers {
        position: relative;
        vertical-align: top;

        &:after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 23px;
            height: 2px;
            background: #ddd;
            width: 100%;
        }
    }

    table.product-comparision__table thead tr:first-child .product-comparison-headers:last-child:after {
        width: calc(100% - 23px);
    }

    table.product-comparision__table thead tr:not(:first-child) th:first-child,
    table.product-comparision__table tbody tr td:first-child {
        border-left: 1px solid #ddd;
    }

    table.product-comparision__table thead tr:not(:first-child) th:last-child,
    table.product-comparision__table tbody tr td:last-child {
        border-right: 1px solid #ddd;
    }

    table.product-comparision__table tbody tr:last-child td {
        border-bottom: 1px solid #ddd;
    }

    .product-comparision .btn-default {
        width: 100%;
    }

    .product-comparision__btn-group .button-special {
        width: 130px;

        &:hover {
            border: none !important;
        }
    }

    .product-comparision__list {
        margin-bottom: 50px;
        padding: 20px 10px 10px 23px;
    }

    .product-comparision__list-item--main {
        padding: 0 10px 10px 23px !important;
        border-bottom: none !important;
        margin-bottom: 15px !important;
    }

    .parametric-intro {
        width: auto !important;
    }

    .product-comparision__cell--bold {
        font-weight: 600;
        color: #000;
    }

    .product-comparision__table-row--bordered {
        border-top: 1px solid #ddd;
        border-right: 1px solid #ddd;
        border-left: 1px solid #ddd;
    }

    .product-comparision__btn-group .button-special .btn {
        text-align: left;
        border-radius: 0;
        font-weight: 400;
    }

    .product-comparision__select {
        max-width: 195px;
    }

    .product-comparision__th:not(.product-comparision__cell--bold) {
        min-width: 249px;
    }

    .product-comparison-headers {
        vertical-align: top;
    }
    .product-comparision__table{
        margin-bottom: 25px;
    }

    .myAmpleon .parametric-intro {
        padding-top: 25px;
    }
</style>

<template>
    <div class="product-comparision">
        <div class="parametric-intro">
            <h3 class="page-title">Comparing products</h3>
        </div>

        <div class="product-comparision__content">
            <div class="product-comparision__row">
                <table class="product-comparision__table">
                    <thead class="product-comparision__thead">
                        <tr class="product-comparision__table-row">
                            <th class="table-actions" rowspan="2">
                                <div class="product-comparision__btn-group">
                                    <div class="button-special">
                                        <a class="btn btn-default" id="save-excel" @click="downloadCompareExcel"
                                           role="button"><i class="lnr lnr-enter-down"></i> save to excel</a>
                                    </div>
                                    <div class="button-special">
                                        <router-link class="btn btn-default" :to="{path: isPublic ?  '/' : '/my-parametric-search'}"><i
                                                class="lnr lnr-undo"></i> go back
                                        </router-link>
                                    </div>
                                </div>
                            </th>
                            <template v-if="isCompareFetchingSuccess">
                                <th class="product-comparison-headers"
                                    v-for="(product, index) in selectedProductParametrics.typeNumber">
                                    <div class="product-comparision__list-item product-comparision__list-item--main">
                                        <a :href="selectedProductParametrics.productDetailsLink[index]"
                                           class="product-comparision__list-anchor">{{product}}</a>
                                        <span class="product-comparision__list-subitem">{{selectedProductParametrics.description[index]}}</span>
                                    </div>
                                </th>
                            </template>
                            <template v-else-if="!isCompareLoading">
                                <th>
                                    <div class="product-comparision__list-item product-comparision__list-item--main">
                                        Internal error.
                                    </div>
                                </th>
                            </template>
                        </tr>
                        <tr v-if="isCompareFetchingSuccess" class="product-comparision__table-row">
                            <td class="product-comparison-headers"
                                v-for="(product, index) in selectedProductParametrics.typeNumber">
                                <ul class="product-comparision__list">
                                    <li class="product-comparision__list-item">
                                        <a :href="selectedProductParametrics.productDetailsLink[index]"
                                           class="product-comparision__list-anchor">Product Details</a>
                                    </li>

                                    <li class="product-comparision__list-item">
                                        <a :href="selectedProductParametrics.dataSheetLink[index]"
                                           class="product-comparision__list-anchor">Datasheet</a>
                                    </li>
                                    <li class="product-comparision__list-item">
                                        <a :href="selectedProductParametrics.productDetailsLink[index] + '#ordering'"
                                           class="product-comparision__list-anchor">Sample / Buy</a>
                                    </li>
                                    <li class="product-comparision__list-item">
                                        <a :href="selectedProductParametrics.productDetailsLink[index] + '#documentation'"
                                           class="product-comparision__list-anchor">Documentation</a>
                                    </li>
                                    <li class="product-comparision__list-item">
                                        <a :href="selectedProductParametrics.productDetailsLink[index] + '#designsupportdocs'"
                                           class="product-comparision__list-anchor">Design Support</a>
                                    </li>
                                </ul>
                            </td>
                        </tr>
                    </thead>
                    <tbody v-if="isCompareFetchingSuccess" class="product-comparision__tbody">
                        <tr class="product-comparision__table-row--bordered">
                            <th class="product-comparision__th product-comparision__cell--bold first-column">Status</th>
                            <th v-for="(product, index) in selectedProductParametrics.status"
                                class="product-comparision__th">{{product}}
                            </th>
                        </tr>
                        <tr class="product-comparision__table-row">
                            <td class="product-comparision__th product-comparision__cell--bold">Package outline</td>
                            <td v-for="(product, index) in selectedProductParametrics.packageName"
                                class="product-comparision__th">
                                <a :href="selectedProductParametrics.packageLink[index]">{{product}}</a></td>
                        </tr>
                        <tr class="product-comparision__table-row">
                            <td class="product-comparision__th product-comparision__cell--bold">F<sub>min</sub> (MHz)
                            </td>
                            <td v-for="product in selectedProductParametrics.frangeMin" class="product-comparision__th">
                                {{product}}
                            </td>

                        </tr>
                        <tr class="product-comparision__table-row">
                            <td class="product-comparision__th product-comparision__cell--bold">F<sub>max</sub> (MHz)
                            </td>
                            <td v-for="product in selectedProductParametrics.frangeMax" class="product-comparision__th">
                                {{product}}
                            </td>
                        </tr>
                        <tr class="product-comparision__table-row">
                            <td class="product-comparision__th product-comparision__cell--bold">P<sub v-if="this.powerLabel === 'ppeak'">peak</sub><sub v-else>L(1dB)</sub> (W)
                            </td>
                            <td v-for="product in selectedProductParametrics.pl1db" class="product-comparision__th">
                                {{product}}
                            </td>
                        </tr>
                        <tr class="product-comparision__table-row">
                            <td class="product-comparision__th product-comparision__cell--bold">P<sub v-if="this.powerLabel === 'ppeak'">peak</sub><sub v-else>L(1dB)</sub> (dBm)
                            </td>
                            <td v-for="product in selectedProductParametrics.pl1dBdBm" class="product-comparision__th">
                                {{product}}
                            </td>
                        </tr>
                        <tr class="product-comparision__table-row">
                            <td class="product-comparision__th product-comparision__cell--bold">V<sub>DS</sub> (V)</td>
                            <td v-for="product in selectedProductParametrics.vds" class="product-comparision__th">
                                {{product}}
                            </td>

                        </tr>
                        <tr class="product-comparision__table-row">
                            <td class="product-comparision__th product-comparision__cell--bold">η<sub>D</sub> (%)</td>
                            <td v-for="product in selectedProductParametrics.nd" class="product-comparision__th">
                                {{product}}
                            </td>

                        </tr>
                        <tr class="product-comparision__table-row">
                            <td class="product-comparision__th product-comparision__cell--bold">G<sub>P</sub> (dB)</td>
                            <td v-for="product in selectedProductParametrics.gp" class="product-comparision__th">
                                {{product}}
                            </td>
                        </tr>
                        <tr class="product-comparision__table-row">
                            <td class="product-comparision__th product-comparision__cell--bold">P<sub>L(AV)</sub> (W)
                            </td>
                            <td v-for="product in selectedProductParametrics.plav" class="product-comparision__th">
                                {{product}}
                            </td>
                        </tr>
                        <tr class="product-comparision__table-row">
                            <td class="product-comparision__th product-comparision__cell--bold">Matching</td>
                            <td v-for="product in selectedProductParametrics.matchingValue"  class="product-comparision__th">{{product}}</td>
                        </tr>
                        <tr class="product-comparision__table-row">
                            <td class="product-comparision__th product-comparision__cell--bold">Recommended line-up</td>
                            <td v-for="product in selectedProductParametrics.recommendedDriver" class="product-comparision__th">
                                <router-link tag="a" :to="{path: product.link}">{{product.label}}</router-link>
                            </td>
                        </tr>
                        <tr class="product-comparision__table-row">
                            <td class="product-comparision__th product-comparision__cell--bold">Test signal</td>
                            <td v-for="(product, index) in selectedProductParametrics.defaultTestSignal"
                                class="product-comparision__th">
                            <span class="product-comparision__select-wrapper">
                                <select v-model="selectedProducts[index].testSignal"
                                        class="product-comparision__select">
                                    <option v-bind:value="test_signal" v-for="(test_signal, index) in product"
                                            class="product-comparision__option">{{test_signal}}</option>
                                </select>
                            </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {FETCH_COMPARABLE_PRODUCTS, DOWNLOAD_COMPARE_EXCEL} from "../../store/actions.type";

    function populatePreselection(actualProduct) {
        const splittedProduct = actualProduct.split('_');
        if (splittedProduct.length === 2) {
            this.selectedProducts.push({
                typeNumber: splittedProduct[0],
                testSignal: splittedProduct[1],
            });
            this.typeNumberSearchParams.append('typeNumber', splittedProduct[0]);
        }
    }

    export default {
        name: "ProductComparison",
        props: {
            isPublic: {
                type: Boolean
            },
        },
        data() {
            return {
                routeQueryParams: this.$route.query.typeNumber,
                typeNumberSearchParams: [],
                actualProductParametrics: {
                    typeNumber: [],
                    description: [],
                    productDetailsLink: [],
                    dataSheetLink: [],
                    orderInformationAvailable: [],
                    status: [],
                    packageName: [],
                    packageLink: [],
                    recommendedDriver: [],
                    frangeMin: [],
                    frangeMax: [],
                    pl1db: [],
                    pl1dBdBm: [],
                    vds: [],
                    nd: [],
                    gp: [],
                    plav: [],
                    matchingValue: [],
                    defaultTestSignal: [],
                },
                selectedProducts: [],
            }
        },
        mounted() {
            if (this.routeQueryParams.length === 0) {
                return;
            }
            this.typeNumberSearchParams = new URLSearchParams();

            //Since the recommended driver page works with one product type number the query has to contain exactly one
            // product type number
            if ('string' === typeof (this.routeQueryParams)) {
                //the query params will be a string if you copy-paste the url
                //parsing the typeNumber from the url query
                this.populatePreselection(this.routeQueryParams);
            } else if ('object' === typeof (this.routeQueryParams) && this.routeQueryParams.length > 0) {
                for (const product in this.routeQueryParams) {
                    if (this.routeQueryParams.hasOwnProperty(product)) {
                        this.populatePreselection(this.routeQueryParams[product]);
                    }
                }
            }


            if(this.productCategory != null) {
              this.typeNumberSearchParams.append('cat', this.productCategory);
            } else if(this.applicationCategory != null) {
              this.typeNumberSearchParams.append('targetApplication', this.applicationCategory);
            }

            this.fetchComparableProducts(this.typeNumberSearchParams);
        },

        computed: {
            ...mapGetters(["isCompareLoading", "isCompareFetchingSuccess", "comparableProducts", "isCompareDownloadSucceed", "powerLabel"]),

            productCategory: function () {
              if (typeof pcat !== "undefined") {
                return pcat;
              } else {
                return null;
              }
            },

            applicationCategory: function () {
              if (typeof acat !== "undefined") {
                return acat;
              } else {
                return null;
              }
            },

            selectedProductParametrics: function () {

                if (Object.keys(this.comparableProducts).length > 0) {
                    this.emptyActualProductValues();
                }
                let index = 0;
                for (const key in this.selectedProducts){
                    const actualUrlProduct = this.selectedProducts[key];
                    const responseProductTypeNumber = Object.keys(this.comparableProducts).filter( product => product === actualUrlProduct.typeNumber);
                    if (responseProductTypeNumber && responseProductTypeNumber.length > 0){
                        const responseProductObject = this.comparableProducts[responseProductTypeNumber];
                        //at this stage I have a product with multiple test signals
                        const responseProductParametrics = Object.keys(responseProductObject.productParametrics).filter(testSignal => testSignal === actualUrlProduct.testSignal);
                        if(responseProductParametrics && responseProductParametrics.length > 0){
                            const responseProductParametricsObject = responseProductObject.productParametrics[responseProductParametrics];
                            if(responseProductParametricsObject){
                                //populating the arrays
                                this.actualProductParametrics.typeNumber.push(responseProductObject.typeNumber);
                                this.actualProductParametrics.description.push(responseProductObject.description);
                                this.actualProductParametrics.productDetailsLink.push(responseProductObject.productDetailsLink);
                                this.actualProductParametrics.dataSheetLink.push(responseProductObject.dataSheetLink);
                                this.actualProductParametrics.orderInformationAvailable.push(responseProductObject.orderInformationAvailable);
                                this.actualProductParametrics.status.push(responseProductObject.status);
                                this.actualProductParametrics.packageName.push(responseProductObject.productPackage.itemName);
                                this.actualProductParametrics.packageLink.push(responseProductObject.productPackage.itemLink);
                                this.actualProductParametrics.frangeMin.push(responseProductParametricsObject.frangeMin);
                                this.actualProductParametrics.frangeMax.push(responseProductParametricsObject.frangeMax);
                                this.actualProductParametrics.pl1db.push(responseProductParametricsObject.pl1dB);
                                this.actualProductParametrics.pl1dBdBm.push(responseProductParametricsObject.pl1dBdBm);
                                this.actualProductParametrics.vds.push(responseProductParametricsObject.vds);
                                this.actualProductParametrics.nd.push(responseProductParametricsObject.nd);
                                this.actualProductParametrics.gp.push(responseProductParametricsObject.gp);
                                this.actualProductParametrics.plav.push(responseProductParametricsObject.plav);
                                this.actualProductParametrics.matchingValue.push(responseProductObject.matching);
                                this.actualProductParametrics.defaultTestSignal.push(Object.keys(responseProductObject.productParametrics));

                                if (responseProductObject.recommendedDriver !== null) {
                                    this.actualProductParametrics.recommendedDriver.push({
                                        link: (this.isPublic ? "" : "/my-parametric-search") + "/recommended-driver?typeNumber="
                                            + responseProductObject.typeNumber + "_" + this.selectedProducts[index].testSignal,
                                        label: "View"
                                    });
                                } else {
                                    this.actualProductParametrics.recommendedDriver.push({});
                                }
                            }
                        }
                    }
                    index++;
                }

                return this.actualProductParametrics;
            },
        },

        methods: {
            fetchComparableProducts(queryParameters) {
                this.$store.dispatch(FETCH_COMPARABLE_PRODUCTS, queryParameters);
            },

            emptyActualProductValues() {
                this.actualProductParametrics.typeNumber = [];
                this.actualProductParametrics.description = [];
                this.actualProductParametrics.productDetailsLink = [];
                this.actualProductParametrics.dataSheetLink = [];
                this.actualProductParametrics.orderInformationAvailable = [];
                this.actualProductParametrics.status = [];
                this.actualProductParametrics.packageName = [];
                this.actualProductParametrics.packageLink = [];
                this.actualProductParametrics.frangeMin = [];
                this.actualProductParametrics.frangeMax = [];
                this.actualProductParametrics.pl1db = [];
                this.actualProductParametrics.pl1dBdBm = [];
                this.actualProductParametrics.vds = [];
                this.actualProductParametrics.nd = [];
                this.actualProductParametrics.gp = [];
                this.actualProductParametrics.plav = [];
                this.actualProductParametrics.recommendedDriver = [];
                this.actualProductParametrics.matchingValue = [];
                this.actualProductParametrics.defaultTestSignal = [];
            },

            downloadCompareExcel() {
                if (this.isCompareFetchingSuccess) {
                    this.$store.dispatch(DOWNLOAD_COMPARE_EXCEL, this.typeNumberSearchParams);
                }
                return false;
            },

            populatePreselection(actualProduct) {
                const splittedProduct = actualProduct.split('_');
                if (splittedProduct.length === 2) {
                    this.selectedProducts.push({
                        typeNumber: splittedProduct[0],
                        testSignal: splittedProduct[1],
                    });

                    //create queryParameter
                    this.typeNumberSearchParams.append('typeNumber', splittedProduct[0]);
                }
            }
        }
    }
</script>